function accordionItem() {
  return {
    isOpen: false,

    init() {
      document.addEventListener("keydown", this.handleEscape.bind(this));
    },

    toggle() {
      this.isOpen = !this.isOpen;
    },

    handleEscape(event) {
      if (event.key === "Escape" && this.isOpen) {
        this.isOpen = false;
      }
    },

    destroy() {
      document.removeEventListener("keydown", this.handleEscape.bind(this));
    }
  };
}

export default accordionItem;
